import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";


const getSportList = (data: any)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.betList.sport.replace('{playerId}', `${data.playerId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getCasinoList = (data: any)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.betList.casino.replace('{playerId}', `${data.playerId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

export const betListService = {
  getSportList,
  getCasinoList,
};
